import React from 'react';
import { Box, Typography } from '@mui/material';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { PARTNER_BRAND, PARTNER_CARD_SX } from '../../partnerDashboardTheme';

const CommunityEmptyState = ({ message }) => (
  <Box
    sx={{
      ...PARTNER_CARD_SX,
      flex: 1,
      minHeight: 360,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      px: 3,
      py: 5,
    }}
  >
    <Box
      sx={{
        width: 72,
        height: 72,
        borderRadius: '50%',
        bgcolor: 'rgba(224, 104, 10, 0.12)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 2,
      }}
    >
      <GroupsOutlinedIcon sx={{ fontSize: 36, color: PARTNER_BRAND }} />
    </Box>

    <Typography sx={{ fontWeight: 700, fontSize: '1.125rem', color: 'text.primary', mb: 1 }}>
      No community channel yet
    </Typography>

    <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, lineHeight: 1.65 }}>
      {message ||
        'Your partner organization does not have a community channel yet. Please contact support if you believe this is an error.'}
    </Typography>
  </Box>
);

export default CommunityEmptyState;
